/*
  Le comportement des pages écrites à la main.

  POURQUOI CE FICHIER EXISTE. Les pages « À propos », « Développement durable »
  et leurs voisines ont été composées en HTML et CSS directement dans le
  contenu de la page, côté Shopify. Le balisage et les styles y survivent, mais
  pas le JavaScript : l'éditeur de page le retire à l'enregistrement. Résultat,
  le lecteur audio affichait un bouton qui ne jouait rien, et les onglets un
  jeu d'onglets qui ne changeait rien.

  Le code est donc ici, dans le thème, où personne ne le nettoie. Il ne fait
  rien tant qu'il ne trouve pas le balisage correspondant : sur les pages qui
  n'ont ni lecteur ni onglets, il se termine en quelques microsecondes.

  Il ne remplace aucun balisage et n'écrit aucun style. Tout ce qu'il fait,
  c'est ajouter et retirer la classe « on », mettre à jour deux compteurs de
  temps, et une largeur en pourcentage. Si vous modifiez le HTML d'une page,
  gardez simplement les identifiants et les classes utilisés ci-dessous.
*/
(function () {
  'use strict';

  /* ─────────────────────────────────────────────── Le lecteur audio ───
     Balisage attendu, tel qu'il est déjà dans vos pages :

       .ag-audio
         audio#agAudioEl
         button#agPlayBtn      svg#agPlayIcon + svg#agPauseIcon
         span#agCurrent  span#agDuration
         #agBar > #agBarFill + #agBarDot

     Le fichier est en preload="metadata" : sa durée n'est connue qu'une fois
     l'en-tête reçu, d'où l'affichage différé du temps total.
  */
  function lecteurAudio() {
    var audio = document.getElementById('agAudioEl');
    var bouton = document.getElementById('agPlayBtn');
    if (!audio || !bouton) return;

    var iconePlay = document.getElementById('agPlayIcon');
    var iconePause = document.getElementById('agPauseIcon');
    var affCourant = document.getElementById('agCurrent');
    var affDuree = document.getElementById('agDuration');
    var barre = document.getElementById('agBar');
    var remplissage = document.getElementById('agBarFill');
    var point = document.getElementById('agBarDot');

    function mmss(s) {
      if (!isFinite(s) || s < 0) return '0:00';
      var m = Math.floor(s / 60);
      var r = Math.floor(s % 60);
      return m + ':' + (r < 10 ? '0' : '') + r;
    }

    function montrerIcone(enLecture) {
      if (iconePlay) iconePlay.style.display = enLecture ? 'none' : '';
      if (iconePause) iconePause.style.display = enLecture ? '' : 'none';
      bouton.setAttribute('aria-label', enLecture ? 'Mettre en pause' : 'Écouter');
      bouton.setAttribute('aria-pressed', enLecture ? 'true' : 'false');
    }

    function majBarre() {
      var d = audio.duration;
      var p = (isFinite(d) && d > 0) ? (audio.currentTime / d) * 100 : 0;
      if (remplissage) remplissage.style.width = p + '%';
      if (point) point.style.left = p + '%';
      if (affCourant) affCourant.textContent = mmss(audio.currentTime);
    }

    /* Le bouton n'a pas de type : dans un formulaire il vaudrait « submit »
       et rechargerait la page. On le fixe, par précaution. */
    bouton.setAttribute('type', 'button');
    montrerIcone(false);

    bouton.addEventListener('click', function () {
      if (audio.paused) {
        var p = audio.play();
        /* Un navigateur peut refuser la lecture (onglet en sourdine, économie
           d'énergie). On ne laisse pas l'icône mentir dans ce cas. */
        if (p && typeof p.catch === 'function') p.catch(function () { montrerIcone(false); });
      } else {
        audio.pause();
      }
    });

    audio.addEventListener('play', function () { montrerIcone(true); });
    audio.addEventListener('pause', function () { montrerIcone(false); });
    audio.addEventListener('ended', function () {
      montrerIcone(false);
      audio.currentTime = 0;
      majBarre();
    });
    audio.addEventListener('timeupdate', majBarre);
    audio.addEventListener('loadedmetadata', function () {
      if (affDuree) affDuree.textContent = mmss(audio.duration);
      majBarre();
    });

    /* Se déplacer dans le morceau, à la souris comme au doigt. */
    if (barre) {
      barre.setAttribute('role', 'slider');
      barre.setAttribute('tabindex', '0');
      barre.setAttribute('aria-label', 'Position dans le morceau');

      var glisse = false;

      function versPosition(clientX) {
        var r = barre.getBoundingClientRect();
        if (!r.width || !isFinite(audio.duration)) return;
        var t = (clientX - r.left) / r.width;
        audio.currentTime = Math.max(0, Math.min(1, t)) * audio.duration;
        majBarre();
      }

      barre.addEventListener('pointerdown', function (e) {
        glisse = true;
        barre.setPointerCapture && barre.setPointerCapture(e.pointerId);
        versPosition(e.clientX);
      });
      barre.addEventListener('pointermove', function (e) { if (glisse) versPosition(e.clientX); });
      barre.addEventListener('pointerup', function () { glisse = false; });
      barre.addEventListener('pointercancel', function () { glisse = false; });

      barre.addEventListener('keydown', function (e) {
        if (!isFinite(audio.duration)) return;
        if (e.key === 'ArrowLeft') { audio.currentTime = Math.max(0, audio.currentTime - 5); e.preventDefault(); }
        if (e.key === 'ArrowRight') { audio.currentTime = Math.min(audio.duration, audio.currentTime + 5); e.preventDefault(); }
        if (e.key === ' ' || e.key === 'Enter') { bouton.click(); e.preventDefault(); }
      });
    }

    /* Si les métadonnées sont déjà là au moment où le script s'exécute. */
    if (audio.readyState >= 1 && affDuree) affDuree.textContent = mmss(audio.duration);
  }

  /* ────────────────────────────────────────────────────── Les onglets ───
     Balisage attendu :

       .ag-tabs > button.ag-tab   (l'actif porte « on »)
       puis, en frères qui suivent, autant de .ag-sec  (l'actif porte « on »)

     L'association se fait par rang : le premier onglet ouvre la première
     section, et ainsi de suite. C'est ce que fait déjà le HTML en place, où
     les sections portent des identifiants dans le désordre (s2, s4, s3) :
     c'est l'ordre d'écriture qui compte, pas le nom.
  */
  function onglets() {
    var groupes = document.querySelectorAll('.ag-tabs');
    Array.prototype.forEach.call(groupes, function (groupe) {
      var boutons = groupe.querySelectorAll('.ag-tab');
      if (!boutons.length) return;

      var sections = [];
      var n = groupe.nextElementSibling;
      while (n && sections.length < boutons.length) {
        if (n.classList.contains('ag-sec')) sections.push(n);
        n = n.nextElementSibling;
      }
      if (sections.length !== boutons.length) return;   /* balisage inattendu : on s'abstient */

      groupe.setAttribute('role', 'tablist');

      function activer(i) {
        Array.prototype.forEach.call(boutons, function (b, k) {
          b.classList.toggle('on', k === i);
          b.setAttribute('aria-selected', k === i ? 'true' : 'false');
          b.setAttribute('tabindex', k === i ? '0' : '-1');
        });
        sections.forEach(function (s, k) {
          s.classList.toggle('on', k === i);
          s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
        });
      }

      Array.prototype.forEach.call(boutons, function (b, i) {
        b.setAttribute('type', 'button');
        b.setAttribute('role', 'tab');
        b.addEventListener('click', function () { activer(i); });
        b.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          var j = (i + d + boutons.length) % boutons.length;
          boutons[j].focus();
          activer(j);
          e.preventDefault();
        });
      });

      /* On respecte l'onglet déjà marqué « on » dans le HTML. */
      var depart = 0;
      Array.prototype.forEach.call(boutons, function (b, i) { if (b.classList.contains('on')) depart = i; });
      activer(depart);
    });
  }

  function demarrer() {
    lecteurAudio();
    onglets();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();

/* ------------------------------------------------------------------
   Menu « colonne silencieuse »
   Le tiroir n'affiche qu'un niveau à la fois : les grandes entrées,
   puis, quand on en choisit une, ses pages qui glissent par-dessus.
   On s'appuie sur le balisage déjà rendu par le thème : les sous-listes
   existent, on se contente de les mettre de côté et de les rappeler.
   ------------------------------------------------------------------ */
(function () {
  var STYLE_ID = 'ag-menu-colonne';
  var GOUTTIERE = '1.5rem';

  var CSS = [
    /* la colonne : un peu plus large, et de l'air */
    '@media screen and (min-width: 750px) { .menu-drawer { width: 32rem; } }',

    /* le premier niveau respire mais reste atteignable jusqu'au bout */
    '.ag-col { position: relative; overflow-y: auto; overflow-x: hidden;',
    '  -webkit-overflow-scrolling: touch; }',
    '.ag-col::-webkit-scrollbar { width: 0; }',

    '.ag-col .menu-drawer__menu > li > a, .ag-col .menu-drawer__menu > li > .ag-col__ouvrir {',
    '  font-family: var(--font-heading--family, Baskervville, serif);',
    '  font-size: 2.3rem; line-height: 1.15; letter-spacing: 0.01em;',
    '  padding: 1rem ' + GOUTTIERE + '; display: flex; align-items: baseline;',
    '  justify-content: space-between; gap: 1.5rem; width: 100%; text-align: left;',
    '  background: none; border: 0; color: inherit; cursor: pointer; text-decoration: none;',
    '}',
    /* le thème ajoute une retrait sur les éléments de liste : on repart de zéro */
    '.ag-col .menu-drawer__menu, .ag-col .menu-drawer__menu > li {',
    '  border: 0; margin: 0; padding: 0; list-style: none;',
    '}',
    /* aucun filet au repos : il se trace de la gauche vers la droite au survol */
    '.ag-col .menu-drawer__menu > li, .ag-col .menu-drawer__menu > li > * {',
    '  border-top: 0 !important; border-bottom: 0 !important; box-shadow: none !important;',
    '}',
    '.ag-col .menu-drawer__menu > li > .ag-col__ouvrir, .ag-col__panneau a {',
    '  position: relative;',
    '}',
    '.ag-col .menu-drawer__menu > li > .ag-col__ouvrir::after, .ag-col__panneau a::after {',
    '  content: ""; position: absolute; left: 1.5rem; right: 1.5rem; bottom: 0; height: 1px;',
    '  background: var(--ag-filet, rgba(0, 0, 0, 0.35));',
    '  transform: scaleX(0); transform-origin: left center;',
    '  transition: transform 0.45s cubic-bezier(0.22, 1, 0.36, 1);',
    '}',
    '.ag-col .menu-drawer__menu > li > .ag-col__ouvrir:hover::after,',
    '.ag-col .menu-drawer__menu > li > .ag-col__ouvrir:focus-visible::after,',
    '.ag-col__panneau a:hover::after, .ag-col__panneau a:focus-visible::after {',
    '  transform: scaleX(1);',
    '}',
    '@media (prefers-reduced-motion: reduce) {',
    '  .ag-col .menu-drawer__menu > li > .ag-col__ouvrir::after, .ag-col__panneau a::after {',
    '    transition: none;',
    '  }',
    '}',

    /* la devise ne s\'affiche plus dans le tiroir : elle reste dans l\'en-tête */
    '.menu-drawer .menu-drawer__localization { display: none; }',
    /* et la bande qui l\'accueillait disparaît avec elle, si elle ne portait que ça */
    '.menu-drawer .menu-drawer__utility-links:not(:has(> *:not(.menu-drawer__localization))) {',
    '  display: none;',
    '}',

    /* quand la liste dépasse, un voile et une flèche annoncent la suite */
    '.ag-col.est-long::after {',
    '  content: "\\2193"; position: sticky; bottom: 0; left: 0; display: block; height: 3rem;',
    '  margin-top: -3rem; pointer-events: none;',
    '  font-family: var(--font-paragraph--family, sans-serif); font-size: 1.3rem;',
    '  line-height: 3.6rem; text-align: right; padding-right: 1.5rem;',
    '  color: rgba(0, 0, 0, 0.45);',
    '  background: linear-gradient(to top, var(--color-background, #fff) 35%, transparent);',
    '  animation: ag-col-descendre 2.4s ease-in-out infinite;',
    '}',
    '@keyframes ag-col-descendre {',
    '  0%, 100% { transform: translateY(0); } 50% { transform: translateY(3px); }',
    '}',
    '@media (prefers-reduced-motion: reduce) { .ag-col.est-long::after { animation: none; } }',

    /* les œuvres et les deux univers ne collent plus à la dernière entrée */
    '.menu-drawer .menu-drawer__featured-content { margin-top: 2.4rem; }',

    /* les deux univers, avec un bloc blanc qui glisse de l\'un à l\'autre */
    '.ag-drawer-tabs { position: relative !important; }',
    '.ag-drawer-tab {',
    '  position: relative; z-index: 1; flex: 1 1 0; text-align: center;',
    '  background: transparent !important; box-shadow: none !important;',
    '  transition: color 0.35s ease;',
    '}',
    '.ag-tabs-bloc {',
    '  position: absolute; z-index: 0; top: 10px; bottom: 10px; left: 0; width: 0;',
    '  background: #fff; box-shadow: 0 1px 4px rgba(0, 0, 0, 0.14);',
    '  transition: none;',   /* à la première pose, le bloc ne glisse pas depuis le bord */
    '}',
    '.ag-tabs-bloc.est-pose {',
    '  transition: transform 0.5s cubic-bezier(0.22, 1, 0.36, 1), width 0.5s cubic-bezier(0.22, 1, 0.36, 1);',
    '}',
    '@media (prefers-reduced-motion: reduce) { .ag-tabs-bloc { transition: none; } }',
    '.ag-col__signe { font-family: var(--font-paragraph--family, sans-serif); font-size: 1.1rem;',
    '  letter-spacing: 0.18em; opacity: 0.4; transform: translateY(-0.2rem); }',
    '.ag-col .menu-drawer__menu > li > .ag-col__ouvrir:hover .ag-col__signe { opacity: 0.85; }',

    /* on retire la sous-liste dépliée du flux */
    '.ag-col .menu-drawer__menu--childlist { display: none; }',

    /* le second niveau, qui recouvre toute la colonne */
    '.ag-col__panneau {',
    '  position: absolute; left: 0; right: 0; bottom: 0;',
    '  background: var(--color-background, #fff);',
    '  transform: translateX(-100%); visibility: hidden; opacity: 0;',
    '  transition: transform 0.55s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.35s ease, visibility 0.55s;',
    '  display: flex; flex-direction: column; z-index: 6;',
    '  overflow-y: auto; overflow-x: hidden; -webkit-overflow-scrolling: touch;',
    '}',
    '.ag-col__panneau::-webkit-scrollbar { width: 0; }',
    '.ag-col__panneau.is-on { transform: translateX(0); visibility: visible; opacity: 1; }',
    '.ag-col__retour {',
    '  font-family: var(--font-paragraph--family, sans-serif); font-size: 1.15rem;',
    '  letter-spacing: 0.08em; opacity: 0.75;',
    '  background: none; border: 0; cursor: pointer; text-align: left; color: inherit;',
    '  padding: 1rem ' + GOUTTIERE + ' 2rem; display: flex; align-items: center; gap: 0.9rem;',
    '}',
    '.ag-col__retour:hover { opacity: 1; }',
    '.ag-col__panneau a {',
    '  font-family: var(--font-heading--family, Baskervville, serif); font-size: 2.3rem;',
    '  line-height: 1.15; padding: 1rem ' + GOUTTIERE + '; display: block; text-decoration: none;',
    '  color: inherit; opacity: 0.8; transition: opacity 0.3s ease;',
    '}',
    '.ag-col__panneau a:hover { opacity: 1; }',
    '.ag-col__panneau a:first-of-type { opacity: 1; }',

    /* le premier niveau s\'efface pendant que le second avance */
    '.ag-col.is-profond .menu-drawer__menu { opacity: 0; transition: opacity 0.3s ease; pointer-events: none; }',
    '.ag-col .menu-drawer__menu { transition: opacity 0.35s ease 0.1s; }',

    '',

    '@media (prefers-reduced-motion: reduce) {',
    '  .ag-col__panneau { transition: none; } .ag-col .menu-drawer__menu { transition: none; }',
    '}'
  ].join('\n');

  /* seule l'initiale prend la capitale : « Carrés de soie », pas « Carrés de Soie » */

  /* les intitulés du thème arrivent en capitales : on les repose en bas de casse */
  function casser(texte) {
    var t = texte.trim().replace(/^\//, '').trim();
    if (t !== t.toUpperCase()) return t;            /* déjà composé, on n'y touche pas */
    return t.toLowerCase().replace(/[^\s'’-]+/g, function (mot, pos) {
      if (pos > 0) return mot;
      return mot.charAt(0).toUpperCase() + mot.slice(1);
    });
  }

  function poserStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* Les deux univers, en bas du tiroir. Ce sont de vrais liens : on ne change
     rien à la navigation, on rend seulement lisible celui où l'on se trouve,
     et le bloc blanc glisse vers celui que l'on désigne. */
  function univers(drawer) {
    var barre = drawer.querySelector('.ag-drawer-tabs');
    if (!barre || barre.dataset.agTabs) return;
    var onglets = barre.querySelectorAll('.ag-drawer-tab');
    if (onglets.length < 2) return;
    barre.dataset.agTabs = '1';

    var bloc = document.createElement('span');
    bloc.className = 'ag-tabs-bloc';
    bloc.setAttribute('aria-hidden', 'true');
    bloc.style.borderRadius = getComputedStyle(onglets[0]).borderRadius;
    barre.insertBefore(bloc, barre.firstChild);

    /* la page courante décide de l'univers, et non une classe figée dans le thème */
    var chemin = location.pathname.toLowerCase();
    var cotéTableaux = /tableau|affiche|expo/.test(chemin);
    var actif = onglets[cotéTableaux ? 1 : 0];
    Array.prototype.forEach.call(onglets, function (o) {
      o.classList.toggle('ag-drawer-tab--active', o === actif);
    });

    function poser(cible, anime) {
      if (!cible.offsetWidth) return;
      if (anime) bloc.classList.add('est-pose');
      bloc.style.width = cible.offsetWidth + 'px';
      bloc.style.transform = 'translateX(' + cible.offsetLeft + 'px)';
    }

    poser(actif, false);
    requestAnimationFrame(function () { bloc.classList.add('est-pose'); });
    window.addEventListener('resize', function () { poser(actif, false); });

    Array.prototype.forEach.call(onglets, function (o) {
      o.addEventListener('mouseenter', function () { poser(o, true); });
      o.addEventListener('focus', function () { poser(o, true); });
      o.addEventListener('click', function () { poser(o, true); });
      o.addEventListener('mouseleave', function () { poser(actif, true); });
      o.addEventListener('blur', function () { poser(actif, true); });
    });
  }

  function construire(nav) {
    if (!nav || nav.dataset.agCol) return;
    nav.dataset.agCol = '1';
    nav.classList.add('ag-col');

    /* les panneaux vivent dans le tiroir entier, pas seulement dans la liste :
       ils doivent aussi recouvrir la devise et les onglets du bas */
    var hote = nav.closest('.menu-drawer__inner-container') || nav.closest('.menu-drawer') || nav;
    if (getComputedStyle(hote).position === 'static') hote.style.position = 'relative';

    var tiroir = nav.closest('.menu-drawer');
    if (tiroir) univers(tiroir);

    var entrees = nav.querySelectorAll(':scope > ul > li');
    var panneaux = [];

    function fermerTout() {
      panneaux.forEach(function (p) { p.classList.remove('is-on'); });
      nav.classList.remove('is-profond');
    }

    Array.prototype.forEach.call(entrees, function (li) {
      var lien = li.querySelector(':scope > a');
      var liste = li.querySelector(':scope > ul');
      if (!lien || !liste) return;

      var titre = casser(lien.textContent);

      /* le lien de premier niveau devient un bouton d'ouverture */
      var bouton = document.createElement('button');
      bouton.type = 'button';
      bouton.className = 'ag-col__ouvrir';
      bouton.setAttribute('aria-expanded', 'false');
      bouton.innerHTML = '<span>' + titre + '</span><span class="ag-col__signe">+</span>';
      lien.parentNode.insertBefore(bouton, lien);
      lien.style.display = 'none';

      /* le panneau du second niveau */
      var panneau = document.createElement('div');
      panneau.className = 'ag-col__panneau';
      var retour = document.createElement('button');
      retour.type = 'button';
      retour.className = 'ag-col__retour';
      retour.innerHTML = '<span aria-hidden="true">&#8592;</span><span>' + titre + '</span>';
      panneau.appendChild(retour);

      /* on ouvre par la page de la rubrique elle-même, sans rien retirer de ses pages */
      var tout = document.createElement('a');
      tout.href = lien.getAttribute('href');
      tout.textContent = 'Tout voir';
      panneau.appendChild(tout);

      Array.prototype.forEach.call(liste.querySelectorAll('a'), function (a) {
        var copie = document.createElement('a');
        copie.href = a.getAttribute('href');
        copie.textContent = casser(a.textContent);
        panneau.appendChild(copie);
      });

      hote.appendChild(panneau);
      panneaux.push(panneau);

      bouton.addEventListener('click', function () {
        fermerTout();
        /* le panneau démarre au sommet de la liste et descend jusqu'en bas du tiroir */
        var h = hote.getBoundingClientRect();
        var n = nav.getBoundingClientRect();
        panneau.style.top = Math.max(0, Math.round(n.top - h.top)) + 'px';
        panneau.classList.add('is-on');
        panneau.scrollTop = 0;
        nav.classList.add('is-profond');
        bouton.setAttribute('aria-expanded', 'true');
      });
      retour.addEventListener('click', function () {
        fermerTout();
        bouton.setAttribute('aria-expanded', 'false');
        nav.scrollTop = 0;
        jauger();
      });
    });

    /* si la liste dépasse la hauteur du tiroir, on le fait sentir */
    function jauger() {
      var reste = nav.scrollHeight - nav.clientHeight - nav.scrollTop;
      /* dès qu'une entrée est entamée en bas, on le fait savoir */
      nav.classList.toggle('est-long', reste > 4);
    }
    nav.addEventListener('scroll', jauger);
    window.addEventListener('resize', jauger);

    /* en refermant le tiroir, on revient au premier niveau */
    var conteneur = nav.closest('.menu-drawer-container');
    if (conteneur) {
      var suivre = function () {
        if (conteneur.open) {
          document.body.classList.add('ag-menu-ouvert');
          setTimeout(jauger, 60);
        } else {
          document.body.classList.remove('ag-menu-ouvert');
          fermerTout();
          nav.scrollTop = 0;
        }
      };
      conteneur.addEventListener('toggle', suivre);
      suivre();
    }
  }

  function demarrer() {
    poserStyle();
    var nav = document.querySelector('.menu-drawer__navigation');
    if (nav) construire(nav);
    return !!nav;
  }

  /* Le tiroir est rendu par le thème après ce script, et il le re-rend parfois
     en cours de route : l'observateur reste donc armé pour toute la visite.
     construire() se garde lui-même de retravailler un tiroir déjà en place,
     la surveillance ne coûte donc qu'un test par mutation. */
  function guetter() {
    demarrer();
    var attendu = false;
    var observateur = new MutationObserver(function () {
      if (attendu) return;
      attendu = true;
      requestAnimationFrame(function () {
        attendu = false;
        var nav = document.querySelector('.menu-drawer__navigation');
        if (nav && !nav.dataset.agCol) construire(nav);
        var tiroir = document.querySelector('.menu-drawer');
        if (tiroir) univers(tiroir);
      });
    });
    observateur.observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('load', demarrer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', guetter);
  } else {
    guetter();
  }
})();
